export default angular
  .module("ScriptJavascriptEditorCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ScriptJavascriptEditorController", [
    "$rootScope",
    "$scope",
    "$stateParams",
    "$window",
    "$location",
    "$anchorScroll",
    "modal",
    "Scripts",
    function (
      $rootScope,
      $scope,
      $stateParams,
      $window,
      $location,
      $anchorScroll,
      modal,
      Scripts,
    ) {
      $scope.publishedVersionPageSize = 10;
      $scope.savedVersionPageSize = 10;
      $scope.publishedVersions = [];
      $scope.savedVersions = [];

      $scope.isJavascriptPublished = false;

      const selectedScriptId = $stateParams.scriptid;

      let codeRecordExists = false;
      $scope.codeRecord = {
        CODE: "",
      };

      const checkIsJavascriptPublished = () => {
        const latest = $scope.publishedVersions[0];

        return !!(latest && latest.CODE === $scope.codeRecord.CODE && $scope.scriptmeta.STATUS === "published");
      };


      const fetchPublishedVersions = () => {
        Scripts.loadPublishedVersions(selectedScriptId, (data) => {
          $scope.publishedVersions = data;
          console.log('🚀 ~ Scripts.loadPublishedVersions ~ data:', data)
          $scope.isJavascriptPublished = checkIsJavascriptPublished();
        });
      };
      const fetchSavedVersions = () => {
        Scripts.loadSavedVersions(selectedScriptId, (data) => {
          $scope.savedVersions = data;
        });
      };
      Scripts.loadScriptJSByID(selectedScriptId, (record) => {
        if (record !== "") {
          $scope.codeRecord = record;
          codeRecordExists = true;
          fetchPublishedVersions();
          fetchSavedVersions();
        }
      });

      // TODO: Refactor save logic. Now only triggered from the menu.
      $scope.save = () => $rootScope.$emit("saveScriptChanges");
      $scope.saveJavascript = () => {
        if ($rootScope.changedFields.get("jsEditor")) {
          Scripts.addOrUpdateJSByScriptId(
            selectedScriptId,
            $scope.codeRecord,
            codeRecordExists,
            $scope.publishedVersions[0] ? $scope.publishedVersions[0].ID : null,
            (data, status) => {
              if (status === 200) {
                Scripts.markSaved("jsEditor");
                codeRecordExists = true;
                $scope.codeRecord.CODE = data.returningCode;
                $scope.scriptmeta.STATUS = data.status;
                $rootScope.scriptjs = $scope.codeRecord;
              }
            },
          );
        }
      };

      $scope.publishJavascript = () => {
        const latest = $scope.publishedVersions[0];
        // TODO: Check this when the publish action might only cause a state change.
        if (latest && latest.CODE === $scope.codeRecord.CODE && $scope.scriptmeta.STATUS === "published") {
          $window.alert("The current JavaScript version matches the latest published version.");
          return;
        }

        modal.createModal("publish-javascript-modal-view", "PublishJavascriptController", {})
          .result.then((result) => {
            if (result.action === "publish") {
              Scripts.publishJavascriptVersion(
                selectedScriptId,
                {
                  CODE: $scope.codeRecord.CODE,
                  VERSION_COMMENT: result.payload.comment,
                },
                (data, status) => {
                  if (status === 200) {
                    fetchPublishedVersions();

                    $scope.scriptmeta.STATUS = data.status;
                  }
                },
              );
            }
          });
      };

      const saveJavascriptListener = $rootScope.$on("saveScriptChanges", $scope.saveJavascript);
      $scope.$on("$destroy", saveJavascriptListener);

      let editorContext;
      $scope.aceOption = {
        required: ["ace/ext/language-tools"],
        advanced: {
          enableSnippets: true,
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          wrap: true,
        },
        mode: "javascript",
        theme: "github",
        showPrintMargin: false,
        onLoad(editor) {
          const session = editor.getSession();

          editorContext = editor;
          session.setTabSize(2);
          session.setNewLineMode("unix");

          if (session.$worker) {
            session.$worker.send("setOptions", [{
              globalstrict: false,
            }]);
          }

          editor.setOptions({
            minLines: 25,
            maxLines: 75,
            autoScrollEditorIntoView: true,
          });
          editor.on("change", () => {
            // Detects only user changes and ignore all programmatically changes
            if (editor.curOp && editor.curOp.command.name) {
              $rootScope.changedFields.set("jsEditor", true);
            }
          });
        },
      };

      const leftMenuBar = $("#left-menu-bar");
      const mainContent = $("#content");
      const fullScreenAnchor = $("#full-screen-anchor");
      const switchScreenMode = (minLines, maxLines, editor, mode) => {
        leftMenuBar.toggleClass("hide-left-menu");
        fullScreenAnchor.toggleClass("btn-fullscreen", mode);
        fullScreenAnchor.toggleClass("btn-normal-screen", !mode);
        mainContent.toggleClass("col-sm-10", mode);
        mainContent.toggleClass("col-sm-12", !mode);
        editor.setOptions({
          minLines,
          maxLines,
          autoScrollEditorIntoView: true,
        });
        editor.resize();
        $location.hash("javascript-editor");
        $anchorScroll();
        return !mode;
      };

      let enableFullScreen = false;
      $scope.toggleFullscreen = () => {
        enableFullScreen = !enableFullScreen
          ? switchScreenMode(100, 125, editorContext, enableFullScreen)
          : switchScreenMode(25, 75, editorContext, enableFullScreen);
      };

      $scope.showVersion = (version, hide = false) =>
        modal.createModal(
          "published-versions-modal",
          "PublishedVersionsModalController",
          {
            publishedVersions: () => $scope.publishedVersions,
            version: () => version,
            selectedScriptId: () => selectedScriptId,
            hide: hide
          },
          "extra-lg",
        );
    },
  ]);
